import { useEffect, useState } from 'react';

const useInfiniteScroll = (onScrollToBottom, { threshold, root, rootMargin } = {}) => {
  const [nodeRef, setNodeRef] = useState(null);
  const [observed, setObserved] = useState();

  useEffect(() => {
    if (!nodeRef || !window.IntersectionObserver) {
      return;
    }
    const observer = new IntersectionObserver(([entry]) => setObserved(entry), {
      threshold,
      root,
      rootMargin,
    });
    observer.observe(nodeRef);
    return () => observer.disconnect();
  }, [nodeRef, threshold, root, rootMargin]);

  useEffect(() => {
    if (observed?.isIntersecting) {
      onScrollToBottom();
    }
  }, [observed, onScrollToBottom]);
  return setNodeRef;
};

export default useInfiniteScroll;
